import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FirstScreen from '../first-screen';
import Question from '../question';
import TestResult from '../testResult';
import './test.css';
import Spinner from '../spinner';
import ErrorBoundry from '../error-boundry';
import TestHeader from './testHeader';
import universalGTM from "./handleAnalytics";

class Test extends Component {
    state = {
        step: 0,
        questions: [],
        count: 0,
        result: [],
        status: true,
        resultText: [],
        loading: true,
        partners: false,
        logoPartnerImage: null,
        quizResults: [],
        groupResultInfo: [],
        group: [],
        testType: null,
        quizName: ''
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.url !== this.props.url) this.updateTest();
    }

    updateGroupResults = (result) => {
        this.setState({
            groupResultInfo: [...this.state.groupResultInfo, result],
            group: [...this.state.group, result]
        })
    }

    onNextStep = () => {
        if (this.state.step === 0) {
            fetch(
                window.location.hostname === 'localhost' ? `http://172.21.0.4/public/quizzes/${this.props.url}/started` : `https://ppc.world/quizzes/api/public/quizzes/${this.props.url}/started`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    }
                },
            ).then(() => {
                const {getData, url} = this.props;
                getData(url).then(({name}) => {
                    return name
                }).then((name) => {
                    this.setState({
                        quizName: name
                    })
                    if (window.location.hostname !== 'localhost') {
                        universalGTM({
                            'event_action': `Тест ${name}`,
                            'event_label': 'Начал тест'
                        });
                    }
                });

            });
        }

        if (this.state.step === this.state.questions.length) {
            fetch(
                window.location.hostname === 'localhost' ? `http://172.21.0.4/public/quizzes/${this.props.url}/finished` : `https://ppc.world/quizzes/api/public/quizzes/${this.props.url}/finished`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            ).then(() => {
                const {getData, url} = this.props;
                getData(url).then(({name}) => {
                    return name
                }).then((name) => {
                    if (window.location.hostname !== 'localhost') {
                        universalGTM({
                            'event_action': `Тест ${name}`,
                            'event_label': 'Завершил тест'
                        });
                    }
                });
            });
        }
        this.setState({
            step: this.state.step + 1
        });
    };

    updateStep = step => {
        this.setState({
            step: step
        });
    };

    updateCount = count => {
        this.setState({
            count: count
        });
    };

    updateTest = () => {
        const {getData} = this.props;
        const {url} = this.props;

        getData(url)
            .then(({questions, result, resultText, quizResults, isPartner, logoPartnerImage, testType}) => {
                this.setState({
                    questions: questions,
                    result,
                    resultText,
                    loading: false,
                    quizResults,
                    partners: isPartner,
                    logoPartnerImage,
                    testType
                });
            })
            .catch(({status}) => {
                this.setState({
                    status: false,
                    loading: false
                });
            });
    };

    render() {
        const {url, getData} = this.props;
        const {
            step,
            questions,
            count,
            result,
            resultText,
            loading,
            partners,
            logoPartnerImage,
            testType
        } = this.state;

        const header = partners ? <TestHeader logo={this.state.logoPartnerImage}/> : null;

        return (
            <ErrorBoundry>
                {loading ? (
                    <Spinner/>
                ) : (

                    <div className="test">
                        {header}
                        <div className="test__body">
                            {step === 0 ? (
                                <FirstScreen
                                    url={url}
                                    onClick={this.onNextStep}
                                    getData={getData}
                                />
                            ) : questions.length < step ? (
                                <TestResult
                                    updateStep={this.updateStep}
                                    testType={this.state.testType}
                                    questions={questions}
                                    count={count}
                                    quizName={this.state.quizName}
                                    updateCount={this.updateCount}
                                    group={this.state.group}
                                    result={result}
                                    resultText={resultText}
                                    groupResultInfo={this.state.groupResultInfo}
                                    quizResults={this.state.quizResults}
                                />
                            ) : (
                                <Question
                                    url={url}
                                    testType={this.state.testType}
                                    onClick={this.onNextStep}
                                    step={step}
                                    updateGroupResult={this.updateGroupResults}
                                    questions={questions}
                                    updateCount={this.updateCount}
                                    updateStep={this.updateStep}
                                />
                            )}
                        </div>
                    </div>
                )}
            </ErrorBoundry>
        );
    }
}

Test.propTypes = {
    url: PropTypes.string.isRequired,
    getData: PropTypes.func.isRequired
};

export default Test;
